import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import ScreenWrapper from "@/components/ScreenWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"
import { scheduleQueryKeys } from "toptaal-shared"
import { fetchUserSchedule } from "@/api/services/schedule"
import { CalendarWithModal } from "@/components/modals/calendar/CalendarWithModal"

export const Route = createFileRoute("/agenda/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "calendar"),
})

function RouteComponent() {
  const { data: user } = useCurrentUserSuspenseQuery()

  return (
    <ScreenWrapper className="p-8 screen-height-minus-navbar">
      <CalendarWithModal
        id={user.data.userId}
        getQueryKey={scheduleQueryKeys.user}
        queryFn={({ id, startDate, endDate }) =>
          fetchUserSchedule({ id, startDate, endDate })
        }
      />
    </ScreenWrapper>
  )
}
